import { mapGetters } from 'vuex';
import { REDEEM_CODE_BUNDLE_TAKE_TYPES } from '@/consts';

export default {
  computed: {
    ...mapGetters("general", ["myBranches", "currentBranch"]),

    branchOptions() {
      let options = [];
      if (this.$permissions.has(this.$permissions.consts.REDEEM_CODE_LIST_NO_BRANCH)) {
        options = [
          {
            value: null,
            text: "品牌組織階層(無隸屬分店)",
          },
        ];
      }

      if (
        (this.$permissions.has(this.$permissions.consts.REDEEM_CODE_LIST_BRANCH)) ||
        options.length === 0
      ) {
        const option1 = this.myBranches.map((branch) => {
          let branchName = `${branch.branch_code} ${branch.name}`;
          return {
            value: branch.id,
            text: branchName,
          };
        });
        options = [
          ...options,
          ...option1,
        ];
      }

      return options;
    },

    takeTypes() {
      return [
        {
          text: "全部",
          value: "",
        },
        {
          text: "直接領取",
          value: REDEEM_CODE_BUNDLE_TAKE_TYPES.DIRECT,
          tooltip: "顯示在優惠券清單，可直接領取；亦可透過網址領券。",
        },
        {
          text: "輸入序號領取",
          value: REDEEM_CODE_BUNDLE_TAKE_TYPES.INPUT_CODE,
          tooltip: "可輸入優惠券序號領券或是透過網址領券。",
        },
        {
          text: "網址領取",
          value: REDEEM_CODE_BUNDLE_TAKE_TYPES.URL_TAKE,
          tooltip: "只能透過網址領券。",
        },
        {
          text: "點數兌換",
          value: REDEEM_CODE_BUNDLE_TAKE_TYPES.POINT,
          tooltip: "顯示在點數專區，使用點數兌換。",
        },
        {
          text: "系統派發",
          value: REDEEM_CODE_BUNDLE_TAKE_TYPES.SYSTEM_ASSIGN,
          tooltip: "於指定情境，由系統直接發券。",
        },
        {
          text: "集點兌換",
          value: REDEEM_CODE_BUNDLE_TAKE_TYPES.LOYALTY_CARD_REDEEM,
          tooltip: "集點卡專用兌換方式。",
        },
      ];
    }
  },

  data() {
    return {
      selectedBranch: {},
    };
  },

  mounted() {
    // 預設為 現在的分店id
    if (this.query.branch_id != null) {
      this.selectedBranch = this.branchOptions.find(
        (option) => option.value === this.query.branch_id
      );
    } else if (this.$permissions.has(this.$permissions.consts.REDEEM_CODE_LIST_NO_BRANCH)) {
      this.selectedBranch = this.branchOptions.find(
        (option) => option.value === null
      );
    } else {
      this.query.branch_id = this.currentBranch.id;
      this.selectedBranch = this.branchOptions.find(
        (option) => option.value === this.currentBranch.id
      );
    }
  },

  methods: {
    getBranchName(branch_id) {
      const option = this.branchOptions.find((option) => option.value === branch_id);
      return option ? option.text : "";
    }
  }
};
